import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = "/oktoken";//设置axios的基础请求路径
// axios.defaults.baseURL = "http://192.168.0.103:8080/";   //设置axios的基础请求路径
axios.defaults.timeout = 1000*60*5;    //设置axios的请求时间
axios.defaults.withCredentials = true;    //对axios进行了拦截封装
axios.defaults.withCredentials = true;//2021-11-05 添加: 允许跨域携带cookie
// axios.defaults.headers = {'Content-Type':'application/json;charset=UTF-8'}
// axios.defaults.crossDomain = true;

axios.loadData = async function (url) {
  const resp = await axios.get(url);
  resp.headers={'Content-Type':'application/json;charset=UTF-8'};
  return resp.data;
}

Vue.prototype.$http = axios; //将axios添加到 Vue的原型，这样一切vue实现都可以使用该对象



// WEBPACK FOOTER //
// ./src/OK_Scott/http.js